import React, { FCX } from 'react';
import styled from '@emotion/styled';

interface Props {
  type?: 'button' | 'submit' | 'reset';
  bg: string;
}

const Component: FCX<Props> = ({ className, children, type = 'button' }) => (
  <button className={className} type={type}>
    {children}
  </button>
);

const StyledComponent = styled(Component)`
  background-color: ${({ bg }) => bg};
  color: #fff;
  border: 0;
  padding: 0.8em 1.6em;
  border-radius: 4px;
  margin-top: 2em;
  font-size: 1.8rem;
  font-weight: 600;
  transition: all 0.4s ease;
  cursor: pointer;
  letter-spacing: 0.1rem;
  outline: 0;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);

  &:hover {
    background-color: var(--color-secondary-dark);
    box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);
  }

  &:active {
    box-shadow: 0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%);
  }
`;

export default StyledComponent;
